// src/app/Layout.jsx
import React from "react";
import { SiteHeader, NavItem } from "../components/layouts/SiteHeader";
import { FooterLegal, ContactLink, SmallPrint } from "../components/layouts//FooterLegal";

// Move global styles here
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/main.scss";

const Layout = ({ children }) => {
  return (
    <div className="app">
      {/* 1. Permanent Header */}
      <SiteHeader>
        <NavItem to="/">Home</NavItem>
        <NavItem to="/contact">Contact</NavItem>
        <NavItem to="/auth/sign-in">Sign In</NavItem>
        <NavItem to="/auth/register">Register</NavItem>
        <NavItem to="/auth/ping">Ping</NavItem>
      </SiteHeader>

      {/* 2. Dynamic Content Area */}
      {/* This is where the Routes from App.jsx render */}
      <main className="content-wrapper">
        {children}
      </main>

      {/* 3. Permanent Footer */}
      <FooterLegal>
        <ContactLink href="/contact">Contact us</ContactLink>
        <SmallPrint>
          © {new Date().getFullYear()} Sustina. All rights reserved.
        </SmallPrint>
      </FooterLegal>
    </div>
  );
};

export default Layout;